<template>
  <router-view />
</template>

<style lang="scss">
#app{
  position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}
@import "./assets/scss/all.scss";
</style>
